import { PersonStatusTier } from '@on3/api';
import { On3IconRecruitBadge } from '@on3/icons';

import styles from './VerifiedBadge.module.scss';

interface VerifiedBadgeProps {
  tier?: PersonStatusTier;
  type?: 'dark' | 'light';
}

export const VerifiedBadge = ({
  tier = PersonStatusTier.Unknown,
  type = 'light',
}: VerifiedBadgeProps) => {
  let badge = 'Verified';

  if (tier === PersonStatusTier.Base) {
    badge = 'Recruit';
  }

  if (tier === PersonStatusTier.Star || tier === PersonStatusTier.Elite) {
    badge = 'Elite';
  }

  return (
    <div className={styles.block} data-badge={badge} data-theme={type}>
      <On3IconRecruitBadge />
      <span className={styles.tier}>{badge}</span>
    </div>
  );
};
